var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 377.999,
    height: 84,
    viewBox: "0 0 377.999 84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "square",
    transform: "translate(-229.497 -114)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57943",
    "data-name": "Group 57943",
    transform: "translate(232 114)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57996",
    "data-name": "Group 57996",
    transform: "translate(-129.981 -343.894)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_58003",
    "data-name": "Group 58003",
    transform: "translate(387.478 343.453)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11644",
    "data-name": "Rectangle 11644",
    width: 118,
    height: 84,
    rx: 5,
    transform: "translate(0 0.441)",
    fill: "#f4f5f7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_58038",
    "data-name": "Group 58038",
    transform: "translate(-46.119 -2.435)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57944",
    "data-name": "Group 57944",
    transform: "translate(75 34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53600",
    "data-name": "Path 53600",
    d: "M258.81,97.184,243.085,81.46a2.156,2.156,0,0,0-3.049,0L220,101.5h43.634Z",
    transform: "translate(-203.396 -79.744)",
    fill: "#e7e9ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53602",
    "data-name": "Path 53602",
    d: "M219.58,85.773,204.6,100.547a2.144,2.144,0,0,0,1.511.621h30.185l-13.47-15.395A2.157,2.157,0,0,0,219.58,85.773Z",
    transform: "translate(-204.598 -79.415)",
    fill: "#1a2d4c"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_833",
    "data-name": "Ellipse 833",
    cx: 3.377,
    cy: 3.498,
    rx: 3.377,
    ry: 3.498,
    transform: "translate(21.709 0)",
    fill: "#e7e9ed"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_58054",
    "data-name": "Group 58054",
    transform: "translate(257.478 343.453)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11644-2",
    "data-name": "Rectangle 11644",
    width: 118,
    height: 84,
    rx: 5,
    transform: "translate(0 0.441)",
    fill: "#f4f5f7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_58038-2",
    "data-name": "Group 58038",
    transform: "translate(-46.119 -2.435)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57944-2",
    "data-name": "Group 57944",
    transform: "translate(75 34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53600-2",
    "data-name": "Path 53600",
    d: "M258.81,97.184,243.085,81.46a2.156,2.156,0,0,0-3.049,0L220,101.5h43.634Z",
    transform: "translate(-203.396 -79.744)",
    fill: "#e7e9ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53602-2",
    "data-name": "Path 53602",
    d: "M219.58,85.773,204.6,100.547a2.144,2.144,0,0,0,1.511.621h30.185l-13.47-15.395A2.157,2.157,0,0,0,219.58,85.773Z",
    transform: "translate(-204.598 -79.415)",
    fill: "#1a2d4c"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_833-2",
    "data-name": "Ellipse 833",
    cx: 3.377,
    cy: 3.498,
    rx: 3.377,
    ry: 3.498,
    transform: "translate(21.709 0)",
    fill: "#e7e9ed"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_58055",
    "data-name": "Group 58055",
    transform: "translate(127.479 343.453)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11644-3",
    "data-name": "Rectangle 11644",
    width: 118,
    height: 84,
    rx: 5,
    transform: "translate(0 0.441)",
    fill: "#f4f5f7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_58038-3",
    "data-name": "Group 58038",
    transform: "translate(-46.119 -2.435)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57944-3",
    "data-name": "Group 57944",
    transform: "translate(75 34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53600-3",
    "data-name": "Path 53600",
    d: "M258.81,97.184,243.085,81.46a2.156,2.156,0,0,0-3.049,0L220,101.5h43.634Z",
    transform: "translate(-203.396 -79.744)",
    fill: "#e7e9ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53602-3",
    "data-name": "Path 53602",
    d: "M219.58,85.773,204.6,100.547a2.144,2.144,0,0,0,1.511.621h30.185l-13.47-15.395A2.157,2.157,0,0,0,219.58,85.773Z",
    transform: "translate(-204.598 -79.415)",
    fill: "#1a2d4c"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_833-3",
    "data-name": "Ellipse 833",
    cx: 3.377,
    cy: 3.498,
    rx: 3.377,
    ry: 3.498,
    transform: "translate(21.709 0)",
    fill: "#e7e9ed"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_53680",
    "data-name": "Path 53680",
    d: "M0,0H68.955",
    transform: "translate(414.535 413.842)",
    fill: "none",
    stroke: "#e7e9ed",
    strokeLinecap: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53681",
    "data-name": "Path 53681",
    d: "M0,0H68.955",
    transform: "translate(282.001 413.842)",
    fill: "none",
    stroke: "#e7e9ed",
    strokeLinecap: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53682",
    "data-name": "Path 53682",
    d: "M0,0H68.955",
    transform: "translate(152.001 413.842)",
    fill: "none",
    stroke: "#e7e9ed",
    strokeLinecap: "round",
    strokeWidth: 5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquare);
export default __webpack_public_path__ + "static/media/square.a6c9660e7f15aba934a47134c79db698.svg";
export { ForwardRef as ReactComponent };